import styled, { css } from 'styled-components'

export const Container = styled.div`
  .cardContainer {
    height: fit-content;
    margin-bottom: 20px;
    max-width: 100%;
    border-radius: 10px;
    break-inside: avoid-column;
    overflow: hidden;
    width: 100%;
  }

  .exceptions {
    justify-content: flex-start !important;
    margin: 20px 0;
  }
`

const variantStyles = (variant = 'success') =>
  ({
    success: css`
      background: #E7FFE5;
    `,
    error: css`
      background: #FFEDED;
    `
  }[variant])

export const Footer = styled.div<{variant: 'success' | 'error'}>`
  ${({ variant }) => variantStyles(variant)}

  display: flex;
  align-items: flex-start;
  border-radius: 0 0 5px 5px;
  justify-content: center;
  padding: 15px;
  margin: 15px -20px -20px;
  gap: 10px;

  > svg {
    min-width: 35px;
  }
`